// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2S9qO","amount":"Amount_amount__28e7M","tip":"Amount_tip__3rVtl","tipHeader":"Amount_tipHeader__1yDJX","tipsWrap":"Amount_tipsWrap__2VmMl"};